module.exports = __webpack_public_path__ + "img/Spoiler.96fdfe83.png";